import { Edges, Text } from "@react-three/drei"
import { useRef, useState } from "react"

export interface IBox {
    id: string,
    color: string;
    position: [number, number, number];
    size: [number, number, number];
    isStackAble: boolean
    isRotationAble: boolean
    isVisible?: boolean
    amount: number
}

const Box = (props: any) => {
    const ref = useRef<THREE.Mesh>(null!)
    const [hovered, hover] = useState(false)

    const [x, y, z] = props.size

    // 각 면에 맞는 offset과 rotation을 props.size 기준으로 계산
    const faces = [
        { posOffset: [0, 0, z / 2 + 0.01], rot: [0, 0, 0] },               // 앞면
        { posOffset: [0, 0, -z / 2 - 0.01], rot: [0, Math.PI, 0] },        // 뒷면
        { posOffset: [x / 2 + 0.01, 0, 0], rot: [0, Math.PI / 2, 0] },     // 오른쪽
        { posOffset: [-x / 2 - 0.01, 0, 0], rot: [0, -Math.PI / 2, 0] },   // 왼쪽
        { posOffset: [0, y / 2 + 0.01, 0], rot: [-Math.PI / 2, 0, 0] },    // 윗면
        { posOffset: [0, -y / 2 - 0.01, 0], rot: [Math.PI / 2, 0, 0] },    // 바닥면
    ]
    // useFrame((_, delta) => (ref.current.rotation.y += delta))

    // const [front, back = ''] = props.title.split(/(?:\s*\(|\))/).filter(Boolean);

    return (
        <group position={props.position}>
            {
                props.isVisible &&
                <mesh
                    ref={ref}
                    castShadow
                    onPointerOver={(e) => {
                        e.stopPropagation();
                        hover(true);
                    }}
                    onPointerOut={(e) => {
                        e.stopPropagation();
                        hover(false);
                    }}
                >
                    <boxGeometry args={props.size} />
                    <meshStandardMaterial color={hovered ? 'red' : props.color} />
                    <Edges scale={1} threshold={15} color="black" />
                </mesh>
            }

            {props.isVisible && faces.map((f, i) => {
                const [boxW] = props.size;
                const textWidth = boxW * 0.9; // 양쪽 5% 여유
                const fontSize = Math.min(0.1, textWidth / 10); // 길이에 따라 크기 조절 (옵션)

                return (
                    <group key={i} position={f.posOffset as any} rotation={f.rot as any}>
                        <Text
                            position={[0, 0.2, 0]}
                            fontSize={fontSize}
                            maxWidth={textWidth}
                            anchorX="center"
                            anchorY="middle"
                            color="black"
                        >
                            {props.id}
                        </Text>

                        <Text
                            position={[0, -0.1, 0]}
                            fontSize={fontSize * 0.8}
                            maxWidth={textWidth}
                            anchorX="center"
                            anchorY="middle"
                            color="black"
                        >
                            ({props.size[0]}m x {props.size[1]}m x {props.size[2]}m)
                        </Text>

                        {/* <Text
                            position={[0, -0.1, 0]}
                            fontSize={fontSize * 0.8}
                            maxWidth={textWidth}
                            anchorX="center"
                            anchorY="middle"
                            color="black"
                        >
                            ({props.position[0]}x x {props.position[1]}y x {props.position[2]}z)
                        </Text> */}
                    </group>
                );
            })}
        </group>
    )
}

export default Box